<template>
    <div>
        <e-dialog
                dialogTitle="对账单确认"
                :centerDialogVisible="visible"
                :showCloseBtn="true"
                :showBtn="false"
                @resetPopupData="resetPopupData"
                 :popupWidth="'600px'">
            <div>
                <div class="reason">对账单确认成功</div>
                <div class="reason" style="margin-top: 10px">请贵公司及时付款，感谢您的合作与支持！</div>
            </div>
        </e-dialog>
    </div>
    
</template>

<script>
    import eDialog from "../../../components/common/e-dialog";
    export default {
        name: "confirmDialog",
        components:{eDialog},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
        },
        methods:{
            resetPopupData(){
                this.$emit('closeDialog');
            },
        },
    }
</script>

<style scoped lang="scss">
    .reason{
        display: flex;
        justify-content: center;
     }
</style>